import { LEADS_ROUTE } from '../contants/routes.contants';

export const checkIsLeadManageLeadomatic = () => {
    const { pathname, search } = window.location;
    const query = new URLSearchParams(search);
    const sourceIsLeadomatic = query.get('isLeadomatic') === 'true';

    return pathname === LEADS_ROUTE.LEADS_MANAGE_LEADOMATIC || sourceIsLeadomatic;
};

export const checkIsLeadManageDeliveryRequested = () => {
    const { pathname, search } = window.location;
    const query = new URLSearchParams(search);
    const sourceIsDeliveryRequested = query.get('isDeliveryRequested') === 'true';

    return pathname === LEADS_ROUTE.LEAD_MANAGE_DELIVERY_REQUESTED || sourceIsDeliveryRequested;
};

export const getLeadPageType = () => {
    const { pathname, search } = window.location;
    const query = new URLSearchParams(search);
    const sourceIsDeliveryRequested = query.get('isDeliveryRequested') === 'true';
    const sourceIsCancelled = query.get('isCancelled') === 'true';
    const sourceIsLeadomatic = query.get('isLeadomatic') === 'true';
    const showHpi = query.get('showHpi') === 'true';

    if (pathname === LEADS_ROUTE.LEADS_MANAGE_LEADOMATIC || sourceIsLeadomatic) {
        return { isLeadomatic: true, isDeliveryRequested: false, isCancelled: false, showHpi };
    }
    if (pathname === LEADS_ROUTE.LEAD_MANAGE_DELIVERY_REQUESTED || sourceIsDeliveryRequested) {
        return { isLeadomatic: false, isDeliveryRequested: true, isCancelled: false, showHpi };
    }
    if (sourceIsCancelled) {
        return { isLeadomatic: false, isDeliveryRequested: false, isCancelled: true, showHpi };
    }
    return { isLeadomatic: false, isDeliveryRequested: false, isCancelled: false, showHpi };
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/utils/index.js